import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <a
        href="https://drive.google.com/drive/folders/1FhlC0W6lFZNuZGKH0NDzOYpkiuxcUSQe?usp=sharing"
        target="_blank"
        className="btn"
      >
        My Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Contact Me
      </a>
    </div>
  );
};

export default CTA;
